import Blue from "../core";

new Blue({
	name: 'Collapsible Table',
	selector: ".collapsible-table",
	setup(container) {
		let items = [...container.querySelectorAll('.collapsible-table__item')];

		items.forEach(item => {
			let trigger = item.querySelector('.collapsible-table__trigger');
			let content = item.querySelector('.collapsible-table__content');
			let togglet = new this.$toggle({
				container: item,
				trigger,
				content
			});

			if (item.matches(".collapsible-table__item--open")) {
				togglet.open();
				setTimeout(() => {
					item.classList.remove("collapsible-table__item--open");
				}, 100);
			}
		});
	}
});